import React from 'react';
export var SideInsertPanel = function SideInsertPanel(_ref) {
  var items = _ref.items,
    onItemInsert = _ref.onItemInsert;
  return /*#__PURE__*/React.createElement("div", null, "Editor Controls Side panel");
};